import React, { useEffect } from "react";
import { NavLink } from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";

const Footer = () => {
  const { t, i18n } = useTranslation();

  const languageOptions = [
    { label: "简体中文", value: "zh_CN" },
    { label: "English", value: "en_CA" },
    { label: "Français", value: "fr_CA" },
  ];

  useEffect(() => {
    const savedLang = localStorage.getItem("miracleLanguage");
    if (savedLang) {
      i18n.changeLanguage(savedLang);
    } else {
      i18n.changeLanguage("en_CA");
      localStorage.setItem("miracleLanguage", "en_CA");
    }
  }, [i18n]);

  const onChangeArea = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem("miracleLanguage", langCode);
  };

  return (
    <div className="footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-10 col-md-10">
            <div className="copy_right">
              © 2025 MIRACLE PACE INC.. All Rights Reserved.
            </div>
          </div>

          {/* <div className="col-xl-4 col-md-4 text-lg-right text-center">
            <div className="social">
              <NavLink to="/" tag={RRNavLink}>
                <i className="fa fa-youtube-play"></i>
              </NavLink>
              <NavLink to="/" tag={RRNavLink}>
                <i className="fa fa-instagram"></i>
              </NavLink>
              <NavLink to="/" tag={RRNavLink}>
                <i className="fa fa-twitter"></i>
              </NavLink>
              <NavLink to="/" tag={RRNavLink}>
                <i className="fa fa-facebook"></i>
              </NavLink>
            </div>
          </div> */}

          <div className="col-xl-1 col-md-1">
            <Dropdown
              value={i18n.language}
              options={languageOptions}
              onChange={(e) => onChangeArea(e.value)}
              style={{ width: "175px", color: "white" }}
              placeholder={t("select.label")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
